(() => {
  const mobileViewport = window.matchMedia('(max-width: 767.98px)');
  let gesture = null;
  let clearGestureTimer = null;

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!mobileViewport.matches || (event.pointerType !== 'touch' && event.pointerType !== 'pen')) return;

      const track = event.target.closest('[data-mobile-product-card-slider]');
      if (!track) return;

      window.clearTimeout(clearGestureTimer);
      gesture = {
        link: track.closest('[data-mobile-product-card-link]'),
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        swiped: false,
      };
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!gesture || gesture.pointerId !== event.pointerId) return;

      const distanceX = Math.abs(event.clientX - gesture.startX);
      const distanceY = Math.abs(event.clientY - gesture.startY);
      if (distanceX > 10 && distanceX > distanceY) gesture.swiped = true;
    },
    { passive: true }
  );

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('[data-mobile-product-card-link]');
      if (!link || gesture?.link !== link || !gesture.swiped) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      gesture = null;
      window.clearTimeout(clearGestureTimer);
    },
    true
  );

  const scheduleGestureReset = () => {
    window.clearTimeout(clearGestureTimer);
    clearGestureTimer = window.setTimeout(() => {
      gesture = null;
    }, 450);
  };

  document.addEventListener('pointerup', scheduleGestureReset, { passive: true });
  document.addEventListener('pointercancel', scheduleGestureReset, { passive: true });
})();
